"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.notIncludes = exports.includes = exports.isNotNull = exports.isNull = exports.notEqual = exports.equal = exports.lessThanOrEqual = exports.lessThan = exports.greaterThanOrEqual = exports.greaterThan = exports.getNodeOutput = void 0;
const interface_1 = require("../../../automation_manager/interface");
const model_1 = require("../../../model");
const view_types_1 = require("../../../types/view_types");
/**
 * all functions under this file are context-based which means they will use something from context
 */
function getNodeOutput(_context, nodeId) {
    if (!_context.executedNodeIds.includes(nodeId)) {
        throw Error(`${nodeId} Does Not Executed!`);
    }
    return _context.context[nodeId].output;
}
exports.getNodeOutput = getNodeOutput;
const getFieldValue = (context, fieldId) => {
    return context.fields[fieldId];
};
/**
 *  we already implement the interface of FOperator which can compare 2 cellValues, so we can use it directly.
 */
const IMagicOperatorMap = {
    [interface_1.OperatorEnums.Equal]: view_types_1.FOperator.Is,
    [interface_1.OperatorEnums.NotEqual]: view_types_1.FOperator.IsNot,
    [interface_1.OperatorEnums.GreaterThan]: view_types_1.FOperator.IsGreater,
    [interface_1.OperatorEnums.GreaterThanOrEqual]: view_types_1.FOperator.IsGreaterEqual,
    [interface_1.OperatorEnums.LessThan]: view_types_1.FOperator.IsLess,
    [interface_1.OperatorEnums.LessThanOrEqual]: view_types_1.FOperator.IsLessEqual,
    [interface_1.OperatorEnums.IsNull]: view_types_1.FOperator.IsEmpty,
    [interface_1.OperatorEnums.IsNotNull]: view_types_1.FOperator.IsNotEmpty,
    [interface_1.OperatorEnums.Includes]: view_types_1.FOperator.Contains,
    [interface_1.OperatorEnums.NotIncludes]: view_types_1.FOperator.DoesNotContain,
};
const makeFunction = (operator, funcName) => {
    const func = (...args) => {
        const [ctx, fieldId, b] = args;
        const fieldMap = ctx.fieldMap;
        const field = fieldMap[fieldId];
        // if the field is deleted, the filter should be invalid. return false
        if (!field)
            return false;
        return model_1.Field.bindContext(field, {}).isMeetFilter(IMagicOperatorMap[operator], getFieldValue(ctx, fieldId), b);
    };
    Object.defineProperty(func, 'name', { writable: false, value: funcName });
    return func;
};
exports.greaterThan = makeFunction(interface_1.OperatorEnums.GreaterThan, 'greaterThan');
exports.greaterThanOrEqual = makeFunction(interface_1.OperatorEnums.GreaterThanOrEqual, 'greaterThanOrEqual');
exports.lessThan = makeFunction(interface_1.OperatorEnums.LessThan, 'lessThan');
exports.lessThanOrEqual = makeFunction(interface_1.OperatorEnums.LessThanOrEqual, 'lessThanOrEqual');
exports.equal = makeFunction(interface_1.OperatorEnums.Equal, 'equal');
exports.notEqual = makeFunction(interface_1.OperatorEnums.NotEqual, 'notEqual');
exports.isNull = makeFunction(interface_1.OperatorEnums.IsNull, 'isNull');
exports.isNotNull = makeFunction(interface_1.OperatorEnums.IsNotNull, 'isNotNull');
exports.includes = makeFunction(interface_1.OperatorEnums.Includes, 'includes');
exports.notIncludes = makeFunction(interface_1.OperatorEnums.NotIncludes, 'notIncludes');
//# sourceMappingURL=context_base.js.map